import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

interface Props {
  active?: boolean;
  background?: string;
}

export const Wrapper = styled.nav`
  font-family: ${FONTS.OPEN_SANS};
  background: #FAFAFA;
  font-size: 14px;
  height: 100%;
  min-height: 50px;
  display: flex;
`;

export const Navigation = styled.ul`
  display: flex;
  flex: 1;
`;

export const Item = styled.li`
  flex: 1;
  >a {
    color: ${COLORS.BLACK};
    font-size: 9px;
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 6px;
    cursor: pointer;
    ${(props:Props) => props.active && css`
      background: ${props.background};
      color: #fff;
      svg {
        fill: #fff;
      }
    `}
    @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
      font-size: 14px;
      ${(props:Props) => props.background && css`
        &:hover {
          background: ${props.background};
          color: #fff;
          svg {
            fill: #fff;
          }
        }
      `}
    }

    @media(min-width: ${SIZE.DESKTOP}) {
      padding: 0 25px;
    }
  }
`;

export const IconWrapper = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MAIN = 'NavBar';
Wrapper.displayName = `${MAIN}/Wrapper`;
Navigation.displayName = `${MAIN}/Navigation`;
Item.displayName = `${MAIN}/Item`;
IconWrapper.displayName = `${MAIN}/IconWrapper`;
